import { NotionIcon } from "#components/ui/NotionIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const notionManifest: IntegrationManifest = {
    key: "notion",
    displayName: "Notion",
    nameKey: "channels.notion",
    descriptionKey: "notionDescription",
    trayDescriptionKey: "composerTrayDescriptions.notion",
    cardDescriptionKey: "connectIntegration.descriptions.notion",
    connectedContentKeys: ["notionPages"],
    brandColor: "#191919",
    iconUrl: IconAssets.Notion,
    iconUrlAlt: IconAssets.NotionAlt,
    glyph: NotionIcon,
    channelType: "UserNotionMcp",
    dataSources: ["notion_page"]
};
